
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import DoneIcon from '@mui/icons-material/Done';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import TableCell from '@mui/material/TableCell';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';


import { IconButton, Switch, Tooltip } from '@mui/material';


const ApiRow = ({ row, updateForm, index, handleActive }) => {
  return (
    <>
      <TableCell component="th" align="center" scope="row" key={index}>
        {row.id}
      </TableCell>
      <TableCell align="center" key={index}>{row.name}</TableCell>
      <TableCell align="center" key={index}>{row.hash}</TableCell>
      <TableCell align="center" key={index}>{row.created_on}</TableCell>
      <TableCell align="center" key={index}>{row.active === '1' ? <CheckIcon /> : <CloseIcon />}</TableCell>
      {/* <TableCell align="center">
        <Switch checked={Boolean(Number(row.active))} onChange={(e, value) => { handleActive(row.id, value) }} />
      </TableCell> */}
      <TableCell align="center" key={index}>
        <Tooltip title="Edit">
          <IconButton onClick={() => { updateForm(row) }}>
            <ModeEditOutlineOutlinedIcon />
          </IconButton>
        </Tooltip>
      </TableCell>
    </>
  );
}

export default ApiRow;